/* eslint-disable */
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { generatePremiumOwnerReceipt } from '../utils/ledger/generatePremiumOwnerReceipt';
import { generatePremiumClientInvoice } from '../utils/ledger/generatePremiumClientInvoice';
import { generatePremiumClientBookingReport } from '../utils/ledger/generatePremiumClientBookingReport';

const RS = 'INR';
const C = {
  navy:   [10, 22, 40],
  gold:   [201, 168, 76],
  goldL:  [226, 201, 126],
  white:  [255, 255, 255],
  gray:   [136, 150, 168],
  light:  [245, 240, 232],
  red:    [233, 69, 96],
  green:  [46, 125, 50],
  border: [212, 184, 106],
  dark:   [30, 30, 30],
  alt:    [253, 250, 243],
};
const GSTIN_MISSING = '⚠ GSTIN not provided';
const DUMMY_GSTIN = new Set(['27ABCDE1234F1Z5', '27ABCDE1234F1Z0']);
const DUMMY_PAN = new Set(['ABCDE1234F']);

const COMPANY = {
  name:    'DEVELOPMENT EXPRESS',
  tagline: 'THE GOLD STANDARD OF INFRASTRUCTURE',
  md:      'Om Chavan | B.Tech (Civil) | Managing Director',
  addr:    'Karad, Satara, Maharashtra - 415110',
  phone:   '+91-8408000084',
  email:   'om.chavan2026@zohomail.in',
  gstin:   (typeof process !== 'undefined' && process.env && process.env.REACT_APP_DE_GSTIN) || '',
  pan:     (typeof process !== 'undefined' && process.env && process.env.REACT_APP_DE_PAN) || '',
};

function displayGstin(value) {
  const v = String(value || '').trim().toUpperCase();
  if (!v || DUMMY_GSTIN.has(v)) return GSTIN_MISSING;
  return v;
}

function displayPan(value) {
  const v = String(value || '').trim().toUpperCase();
  if (!v || DUMMY_PAN.has(v)) return '⚠ PAN not provided';
  return v;
}

function money(n) { return `${RS} ${Number(n).toLocaleString('en-IN')}`; }
function pct(n, p) { return Math.round(n * p / 100); }
function safeFilePart(value, fallback) {
  return String(value || fallback || 'Report')
    .trim()
    .replace(/[\\/:*?"<>|]+/g, '')
    .replace(/\s+/g, '_')
    .slice(0, 60);
}

function drawHeader(doc, title, sub) {
  const W = doc.internal.pageSize.getWidth();
  doc.setFillColor(...C.navy);
  doc.rect(0, 0, W, 55, 'F');
  doc.setFillColor(...C.gold);
  doc.rect(0, 0, W, 1.5, 'F');
  doc.setFillColor(...C.gold);
  doc.circle(20, 18, 10, 'F');
  doc.setFillColor(...C.navy);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(...C.navy);
  doc.text('DE', 20, 21, { align: 'center' });
  doc.setTextColor(...C.goldL);
  doc.setFontSize(15);
  doc.setFont('helvetica', 'bold');
  doc.text(COMPANY.name, 34, 13);
  doc.setTextColor(...C.gold);
  doc.setFontSize(6.5);
  doc.text(COMPANY.tagline, 34, 18);
  doc.setTextColor(...C.white);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(7);
  doc.text(COMPANY.md, 34, 23);
  doc.text(COMPANY.addr, 34, 28);
  doc.text(`${COMPANY.phone}   ${COMPANY.email}`, 34, 33);
  doc.setTextColor(...C.gold);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(7.5);
  doc.text(`GSTIN: ${displayGstin(COMPANY.gstin)}`, W - 10, 13, { align: 'right' });
  doc.setTextColor(...C.white);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(7);
  doc.text(`PAN: ${displayPan(COMPANY.pan)}`, W - 10, 18, { align: 'right' });
  doc.text('State: Maharashtra (27)', W - 10, 23, { align: 'right' });
  doc.setFillColor(...C.gold);
  doc.rect(0, 40, W, 15, 'F');
  doc.setTextColor(...C.navy);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(13);
  doc.text(title, W / 2, 49, { align: 'center' });
  doc.setFontSize(7);
  doc.text(sub, W / 2, 54, { align: 'center' });
}

function drawMeta(doc, items) {
  const W = doc.internal.pageSize.getWidth();
  doc.setFillColor(...C.navy);
  doc.rect(0, 56, W, 16, 'F');
  items.forEach(([label, val, x]) => {
    doc.setTextColor(...C.gold);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(6.5);
    doc.text(label, x, 62);
    doc.setTextColor(...C.white);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.text(String(val), x, 69);
  });
}

function drawInfoBox(doc, x, y, w, h, title, rows) {
  doc.setFillColor(...C.light);
  doc.rect(x, y, w, h, 'F');
  doc.setDrawColor(...C.border);
  doc.setLineWidth(0.4);
  doc.rect(x, y, w, h, 'S');
  doc.setFillColor(...C.navy);
  doc.rect(x, y, w, 8, 'F');
  doc.setTextColor(...C.gold);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(8);
  doc.text(title, x + 3, y + 5.5);
  rows.forEach(([k, v], i) => {
    const ry = y + 12 + i * 6;
    doc.setTextColor(...C.gray);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(7);
    doc.text(k, x + 3, ry);
    doc.setTextColor(...C.dark);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7.5);
    doc.text(String(v), x + 28, ry);
  });
}

function drawTotals(doc, y, rows, finalLabel, finalVal) {
  const W = doc.internal.pageSize.getWidth();
  const tx = 125, tw = W - tx - 10;
  rows.forEach(([label, val, bg, vc]) => {
    doc.setFillColor(...bg);
    doc.rect(tx, y, tw, 8, 'F');
    doc.setDrawColor(...C.border);
    doc.setLineWidth(0.3);
    doc.rect(tx, y, tw, 8, 'S');
    doc.setTextColor(...C.gray);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.text(label, tx + 3, y + 5.5);
    doc.setTextColor(...vc);
    doc.setFont('helvetica', 'bold');
    doc.text(val, W - 12, y + 5.5, { align: 'right' });
    y += 8;
  });
  doc.setFillColor(...C.navy);
  doc.rect(tx, y + 1, tw, 12, 'F');
  doc.setTextColor(...C.gold);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.text(finalLabel, tx + 3, y + 9);
  doc.text(finalVal, W - 12, y + 9, { align: 'right' });
  return y + 14;
}

function drawFooter(doc, label) {
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  doc.setFillColor(...C.navy);
  doc.rect(0, H - 14, W, 14, 'F');
  doc.setFillColor(...C.gold);
  doc.rect(0, H - 14, W, 0.5, 'F');
  doc.setTextColor(...C.goldL);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(7.5);
  doc.text('Development Express  |  The Gold Standard of Infrastructure', W / 2, H - 8.5, { align: 'center' });
  doc.setTextColor(...C.white);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(6.5);
  doc.text(`${COMPANY.phone}  |  ${COMPANY.email}  |  Karad, Satara  |  Since 2011`, W / 2, H - 4.5, { align: 'center' });
  doc.setTextColor(...C.gold);
  doc.setFontSize(6);
  doc.text(`${label}  |  Generated: ${new Date().toLocaleString('en-IN')}`, W / 2, H - 1.5, { align: 'center' });
}

// ══════════════════════════════════════════════
// 1. GST INVOICE (Premium — same tier as Owner Receipt)
// ══════════════════════════════════════════════
export async function generateGSTInvoice(booking, options) {
  return generatePremiumClientInvoice(booking, options);
}

// ══════════════════════════════════════════════
// 2. OWNER PAYMENT RECEIPT (Premium — Enterprise Edition)
// ══════════════════════════════════════════════
export async function generateOwnerReceipt(booking) {
  return generatePremiumOwnerReceipt(booking);
}

// ══════════════════════════════════════════════
// 3. INTERNAL LEDGER
// ══════════════════════════════════════════════
export function generateInternalLedger(booking) {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const W = doc.internal.pageSize.getWidth();

  drawHeader(doc, 'INTERNAL TRANSACTION LEDGER', '(Confidential — Development Express Use Only)');
  drawMeta(doc, [
    ['Transaction ID:', booking.txnId || 'DE/TXN/INT/2026/041001', 10],
    ['Date:', booking.date || new Date().toLocaleDateString('en-IN'), 70],
    ['Booking Ref:', booking.bookingId || 'BK-2026-041001', 115],
    ['Prepared By:', 'Om Chavan | MD', 165],
  ]);

  const gross = booking.grossAmount || 105000;
  const commPct = booking.commissionPct || 15;
  const comm = pct(gross, commPct);
  const tds = pct(gross, 2);
  const gstTcs = pct(gross, 1);
  const gstPayable = pct(gross, 18);
  const ownerNet = gross - comm - tds - gstTcs;
  const clientTotal = gross + gstPayable;
  const compRev = comm;

  // Summary cards
  const cw = (W - 25) / 3;
  [
    ['CLIENT BILLED', money(clientTotal), booking.clientName || 'Patil Builders', C.green],
    ['OWNER PAID', money(ownerNet), booking.ownerName || 'Rajesh Patil', [21, 101, 192]],
    ['COMPANY REVENUE', money(compRev), 'Net Commission Income', C.gold],
  ].forEach(([title, val, sub, vc], i) => {
    const cx = 10 + i * (cw + 2.5);
    doc.setFillColor(...C.navy);
    doc.rect(cx, 75, cw, 22, 'F');
    doc.setDrawColor(...C.gold);
    doc.setLineWidth(0.8);
    doc.rect(cx, 75, cw, 22, 'S');
    doc.setTextColor(...C.gold);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7);
    doc.text(title, cx + cw / 2, 82, { align: 'center' });
    doc.setTextColor(...vc);
    doc.setFontSize(11);
    doc.text(val, cx + cw / 2, 89, { align: 'center' });
    doc.setTextColor(...C.gray);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(6);
    doc.text(sub, cx + cw / 2, 94, { align: 'center' });
  });

  // Ledger table
  autoTable(doc, {
    startY: 100,
    head: [['Particulars', 'Party', 'Debit', 'Credit', 'Net']],
    body: [
      ['Client Invoice Raised', booking.clientName || 'Patil Builders', '', money(clientTotal), money(clientTotal)],
      [`Commission (${commPct}%)`, 'Development Express', money(comm), '', money(comm)],
      ['TDS Collected (2%)', 'Govt. of India', money(tds), '', money(tds)],
      ['GST TCS (1%)', 'Govt. of India', money(gstTcs), '', money(gstTcs)],
      ['Payment to Owner', booking.ownerName || 'Rajesh Patil', money(ownerNet), '', `- ${money(ownerNet)}`],
      ['GST Output Payable', 'GST Portal', money(gstPayable), '', `- ${money(gstPayable)}`],
    ],
    styles: { font: 'helvetica', fontSize: 7.5, cellPadding: 3, valign: 'middle' },
    headStyles: { fillColor: C.navy, textColor: C.gold, fontStyle: 'bold', fontSize: 7.5 },
    alternateRowStyles: { fillColor: C.alt },
    columnStyles: {
      0: { cellWidth: 65, fontStyle: 'bold' },
      1: { cellWidth: 45 },
      2: { cellWidth: 28, halign: 'right', textColor: C.red },
      3: { cellWidth: 28, halign: 'right', textColor: C.green },
      4: { cellWidth: 28, halign: 'right', fontStyle: 'bold' },
    },
    margin: { left: 10, right: 10 },
  });

  let y = doc.lastAutoTable.finalY + 4;

  // Net revenue bar
  doc.setFillColor(...C.navy);
  doc.rect(10, y, W - 20, 10, 'F');
  doc.setTextColor(...C.gold);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('NET COMPANY REVENUE (This Transaction):', 13, y + 7);
  doc.text(money(compRev), W - 12, y + 7, { align: 'right' });
  y += 13;

  // MTD Summary box — height 38
  doc.setFillColor(...C.light);
  doc.rect(10, y, W - 20, 38, 'F');
  doc.setDrawColor(...C.border);
  doc.setLineWidth(0.4);
  doc.rect(10, y, W - 20, 38, 'S');
  doc.setFillColor(...C.navy);
  doc.rect(10, y, W - 20, 7, 'F');
  doc.setTextColor(...C.gold);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(7.5);
  doc.text('MONTH-TO-DATE SUMMARY - APRIL 2026', 13, y + 5);

  // Row 1
  [['Total Client Billing:', money(321770), 13], ['Total Owner Payments:', money(245000), 75], ['Total Commission:', money(48266), 138]].forEach(([label, val, x]) => {
    doc.setTextColor(...C.gray); doc.setFont('helvetica', 'normal'); doc.setFontSize(6.5);
    doc.text(label, x, y + 14);
    doc.setTextColor(...C.navy); doc.setFont('helvetica', 'bold'); doc.setFontSize(8);
    doc.text(val, x, y + 20);
  });

  // Row 2
  [['Total TDS Collected:', money(6435), 13], ['Total GST Output:', money(57919), 75], ['Net Company Profit:', money(48266), 138]].forEach(([label, val, x]) => {
    doc.setTextColor(...C.gray); doc.setFont('helvetica', 'normal'); doc.setFontSize(6.5);
    doc.text(label, x, y + 27);
    doc.setTextColor(...C.navy); doc.setFont('helvetica', 'bold'); doc.setFontSize(8);
    doc.text(val, x, y + 33);
  });
  y += 42;

  // Confidential
  doc.setTextColor(...C.red);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(7);
  doc.text('CONFIDENTIAL: Internal use only. Not to be shared with any third party.', 10, y + 5);
  y += 11;

  // Signature
  doc.setDrawColor(...C.navy);
  doc.setLineWidth(0.8);
  doc.line(W - 68, y + 4, W - 12, y + 4);
  doc.setTextColor(...C.navy);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(7.5);
  doc.text('Verified & Approved', W - 40, y + 9, { align: 'center' });
  doc.setTextColor(...C.gray);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(7);
  doc.text('Om Chavan | Managing Director', W - 40, y + 14, { align: 'center' });

  drawFooter(doc, 'Internal Ledger | Strictly Confidential');
  doc.save(`DE_Internal_Ledger_${booking.bookingId || 'BK041001'}.pdf`);
}

// ══════════════════════════════════════════════
// 4. BOOKING HISTORY REPORT (Premium — same tier as Owner Receipt)
// ══════════════════════════════════════════════
export async function generateBookingReport(bookings, clientName, options) {
  return generatePremiumClientBookingReport(bookings, clientName, options);
}
